var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPcb3D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 16.25v-3h-3.75v-4.5h-4.5V5h-3v3.75H22V5h-3v3.75h-2.25V5h-3v3.75h-4.5v4.5H5.5v3h3.75v2.25H5.5v3h3.75v2.25H5.5v3h3.75v4.5h4.5V35h3v-3.75H19V35h3v-3.75h2.25V35h3v-3.75h4.5v-4.5h3.75v-3h-3.75V21.5h3.75v-3h-3.75v-2.25h3.75zm-6.75 12h-16.5v-16.5h16.5v16.5zm-3.27-10.095-.24.255-4.035 4.035a.961.961 0 0 1-.72.3.92.92 0 0 1-.69-.3L15.76 18.41l-.24-.255 1.41-1.41.24.255 2.34 2.34V14h1.995v5.34l2.34-2.34.24-.255 1.41 1.41h-.015zM16 23.75h9V26h-9v-2.25z",
    fill: "#EF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcb3D);
export default __webpack_public_path__ + "static/media/pcb-3d.a938577c44596ca62c6cf400b62c21c0.svg";
export { ForwardRef as ReactComponent };